import { Vendor } from "./form";

const CreateVendor = () => {
  return <Vendor />;
};

export default CreateVendor;
